module.exports = __webpack_public_path__ + "static/cloud-dev-stack-shaded-f27c652b2420526d3df9b1d861b65f45.svg";